import { LoadingOutlined } from '@ant-design/icons';
import { Layout, Spin } from 'antd';
import React from 'react';

function AppLoading() {
  return (
    <Layout>
      <Layout.Content className="min-h-screen p-12 pt-24 flex justify-center">
        <Spin indicator={<LoadingOutlined spin />} />
      </Layout.Content>
    </Layout>
  );
}

export default AppLoading;
